


















import { Prop, Component, Vue } from "vue-property-decorator";
import TopPageApi from "@/general/api/topPageApi";

@Component({
  name: "SpecialPageDetail",
})
export default class SpecialPageDetail extends Vue {
  @Prop({ type: Object, default: null }) cms_response!: object;

  data: any = null;
  sp_id: string = "";
  title: string = "";
  fullHtml: string = "";
  js_code: string = "";
  error: string = "";

  async mounted() {
    await this.readcms();
    if(this.js_code !== null) {
      this.jsGen();
    }
  }

  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.sp_id = urlParams.get("spid") || "";
    await this.readcms();
  }

  async readcms() {
    const APIres = await TopPageApi.getSpecialPage({
      sp_id: this.sp_id,
    });
    if (APIres.isError) {
      this.error = "コンテンツの読み込みに失敗しました"
    } else {
      return this.setData(APIres);
    }
  }

  setData(obj: any) {
    if (
        !obj ||
        !obj.data ||
        !obj.included ||
        !obj.included[0] ||
        obj.data.length >= 2
    ) {
      return this.error = "データが不正です。";
    }
    this.title = obj.data[0].attributes.display_title;
    this.$emit('catchTitle', this.title);
    this.js_code = obj.data[0].attributes.js_code;

    const dataId = obj.data[0].relationships.paragraphs.data[0].id;
    const includeData = obj.included.filter(
        (x:any) => x.id === dataId
    )

    const itemValue = includeData.find((el: { type: string; }) => el.type === "paragraph--full_html");

    if(!itemValue) {
      return this.error = "ご選択いただいたページは現在存在しないか、ご利用いただけません。";
    }
    this.fullHtml = itemValue.attributes.field_fullhtml_text.value;
  }

  jsGen() {
    let str = this.js_code;
    let jqueryCode = new Function(str);
    setTimeout(() => {
      jqueryCode();
    }, 10);
  }
}
